import { GraduationCap, Groups, Users } from 'assets/Icons'

const Info = ({ teachers = 0, students = 0, groups = 0 }) => {
	return (
		<div className='border-[#E4E4E4] dark:border-[#FFFFFF33] border-[1px] rounded-[15px]  bg-[linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(97.29deg,rgba(161,158,158,0.15)_-0.29%,rgba(255,255,255,0)_51.75%,rgba(161,158,158,0.15)_102.8%)] dark:bg-[linear-gradient(0deg,rgba(171,171,171,0.03),rgba(171,171,171,0.03)),linear-gradient(98.23deg,rgba(255,255,255,0.13)_-1.89%,rgba(73,73,73,0)_51.47%,rgba(255,255,255,0.13)_104.51%)] backdrop-filter-[blur(7px)]'>
			<div className='flex flex-col gap-5 p-4'>
				<div className='flex items-center justify-between border-[#E7E7E7] dark:border-[#FFFFFF12] border-[1px] rounded-[10px] backdrop-filter-[blur(15px)] dark:backdrop-filter-[blur(15px)] py-3 px-3 gap-3 dark:bg-transparent bg-[#F0F0F0]'>
					<div className='flex items-center gap-2 lg:gap-3'>
						<p className='text-[#018ECC] dark:text-white'>
							<GraduationCap />
						</p>
						<p className='text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
							O’quvchilar
						</p>
					</div>
					<div className='flex items-center'>
						<p className='text-[18px] text-[#292A32] dark:text-[#FFFFFF] font-medium'>
							{students}
						</p>
					</div>
				</div>
				<div className='flex items-center justify-between border-[#E7E7E7] dark:border-[#FFFFFF12] border-[1px] rounded-[10px] backdrop-filter-[blur(15px)] dark:backdrop-filter-[blur(15px)] py-3 px-3 gap-3 dark:bg-transparent bg-[#F0F0F0]'>
					<div className='flex items-center gap-2 lg:gap-3'>
						<p className='text-[#018ECC] dark:text-white'>
							<Users />
						</p>
						<p className='text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
							O’qituvchilar
						</p>
					</div>
					<div className='flex items-center'>
						<p className='text-[18px] text-[#292A32] dark:text-[#FFFFFF] font-medium'>
							{teachers}
						</p>
					</div>
				</div>
				<div className='flex items-center justify-between border-[#E7E7E7] dark:border-[#FFFFFF12] border-[1px] rounded-[10px] backdrop-filter-[blur(15px)] dark:backdrop-filter-[blur(15px)] py-3 px-3 gap-3 dark:bg-transparent bg-[#F0F0F0]'>
					<div className='flex items-center gap-2 lg:gap-3'>
						<p className='text-[#018ECC] dark:text-white'>
							<Groups />
						</p>
						<p className='text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
							Guruhlar
						</p>
					</div>
					<div className='flex items-center'>
						<p className='text-[18px] text-[#292A32] dark:text-[#FFFFFF] font-medium'>
							{groups}
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Info
